import React, {
  useState,
  // useEffect,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../Assets/css/table_grid.css";
import toast from "react-hot-toast";
import { get } from "../Network/requests";
import { getUrl } from "../Network/urls";
import { tokenExpire } from "../Utils";
import Loader from "./UI/Loader";
import NoDataFoundComponent from "./UI/NoDataFoundComponent";
import AppContext from "../Store/AppContext";
// import NotSubscribedMessageComponent from "../components/NotSubscribedMessageComponent";

function ISINSearchComponent() {
  // const subscribtion = "false";
  const [disabledDownloadBtn, setShowDownloadBtn] = useState(true);
  const [loading, setLoading] = useState(true);
  const {
    // secretAccessId,
    // secretAccessKey,
    clientDetails,
    handleEncryptOtherParamsOfAPI,
    // encryptedClientValuesObj,
    // inputBucketName,
    handleDecryptResponse,
    handleAPIEncryptValue,
    // handleTextColorOfOutputFiles,
    handleEncryptValue,
    handleDecryptedValue,
  } = useContext(AppContext);
  // const [isProductAccessible, setIsProductAccessible] = useState(false);
  const [rowData, setRowData] = useState([]);
  const rowData1 = [];
  // const [filesData, setFilesData] = useState({});
  const [columnData, setColumnData] = useState([]); // let gridApi;
  const gridRef = useRef();
  const val = "ISIN";
  const [searchData, setSearchData] = useState("");
  const [showComponent, setShowComponent] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  // const columnDefs = [
  //   {
  //     field: "athlete",
  //     // pinned: 'left',
  //     lockPosition: true,
  //   },
  //   { field: "age" },
  //   { field: "country" },
  //   { field: "year" },
  //   { field: "date" },
  //   { field: "sport" },
  //   { field: "gold" },
  //   { field: "silver" },
  //   { field: "bronze" },
  //   { field: "total" },
  // ];
  const navigate = useNavigate();
  const productCode = "P003";
  const regulationCode = "R006";
  // const clientData = JSON.parse(localStorage.getItem("clientDetails"));

  const getISINData = () => {
    setShowComponent(false);
    setLoading(false);
    setIsLoading(true);
    // console.log('---Inside GetISIN()')
    //   e.preventDefault();
    const url = getUrl("get-refdata");
    const encryptedRole = handleEncryptValue(clientDetails.role);
    const encryptedClientId = handleEncryptValue(clientDetails.clientId);
    // console.log(handleDecryptedValue(encryptedRole), '======',handleDecryptedValue(encryptedClientId));
    const paramsObj = { productCode, regulationCode };
    const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
    // console.log(clientDetails);
    const encryptedVal = handleEncryptValue(val);
    const encryptedSearchData = handleEncryptValue(searchData);
    const data = {
      client_id: encryptedClientId,
      product: encryptedParamsObj.productCode,
      regulation: encryptedParamsObj.regulationCode,
      val: encryptedVal,
      search_data: encryptedSearchData,
      email_id: clientDetails.email,
    };
    // console.log(data, "--data");
    const regdataData = handleAPIEncryptValue(JSON.stringify(data));
    // get(
    //   `${url}?client_id=${clientData.clientId}&product_id=${productCode}&reg_id=${regulationCode}&val=${val}&search_data=${searchData}`,
    //   true
    // )
    get(`${url}?regdata=${regdataData}`, true)
      .then((response) => {
        const {
          data: { encryptBody, statusCode, authData },
        } = response;
        // console.log(response, '--response');
        // console.log(body, '--body');
        let finalArr; // uncomment
        switch (statusCode) {
          case 200:
            // body.data.map((item) => finalArr.push(
            //   item.reduce(
            //     (prev, next, index) => ({
            //       ...prev,
            //       [body.columns[index]]: next,
            //     }),
            //     {},
            //   ),
            // ));
            const iv = authData;
            const idToken = localStorage.getItem("userToken");
            const secretKey = idToken.slice(998, 1030);
            const body = handleDecryptResponse(
              encryptBody.toString(),
              secretKey.toString(),
              iv.toString()
            );
            // console.log(body, '--body');
            setShowDownloadBtn(false);
            body.data.forEach((dataArray) => {
              const rowDataItem = {};
              body.columns.forEach((columnName, columnIndex) => {
                if (columnIndex < dataArray.length) {
                  rowDataItem[columnName] = dataArray[columnIndex];
                } else {
                  rowDataItem[columnName] = "";
                }
              });
              rowData1.push(rowDataItem);
            });
            // console.log(body.data, 'Body.Data');
            setRowData(rowData1);
            // -------------------------------------------
            // setRowData(body.data);
            finalArr = body.columns.map((columnName) => ({
              field: columnName,
            }));
            setColumnData(finalArr);
            // console.log(finalArr, '---finalArr');
            setIsLoading(false);
            // console.log(body, '---body');
            // setColumnData(body.columns);
            // console.log(rowData, '---rowData');
            // console.log(columnData, '---columnData');
            toast.success("Successfully fetched files.");
            break;
          case 400:
            toast.error("Error fetching the files.");
            setLoading(false);
            setIsLoading(false);
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        setLoading(false);
        setIsLoading(false);
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        // setIsLoading(false);
      });
  };

  // const regulationCodeHandler = (e) => {
  //   // console.log(e, '--e');
  //   // console.log(e.target.value, '--e.target');
  //   setRegulationCode(e.target.value);
  // };

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      // enableRowGroup: true,
      floatingFilter: true,
      editable: true,
      resizable: true,
    }),
    []
  );

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  // useEffect(() => {
  //   getGridData();
  // }, []);

  return (
    <>
      {isLoading && <Loader />}
      <main className="middle_section dashboard_middle">
        <div className="container">
          {/* <NotSubscribedMessageComponent /> */}
          <div className="dashboard_header">
            <text label="ISIN" classNameStyle="rx_form_label" />
            <input
              type="text"
              placeholder="Enter ISIN"
              name="input-email"
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              onBlur={() => {}}
              onFocus={() => {}}
              className="text-box-grid common-styles-grid"
            />
            <button
              className={
                !disabledDownloadBtn ? "dash_btn" : " dash_btn opacity-75"
              }
              type="submit"
              disabled={!searchData}
              onClick={getISINData}
            >
              Search
            </button>
            <button
              className={
                !disabledDownloadBtn ? "dash_btn" : " dash_btn opacity-75"
              }
              type="submit"
              disabled={disabledDownloadBtn}
              onClick={onBtnExport}
            >
              Download CSV
            </button>
          </div>
          {!loading ? (
            <div className="dashboard_inner">
              <div className="rx_table_wrapper table-responsive padding-fix">
                <div className="ag-theme-alpine" style={{ height: 600 }}>
                  <AgGridReact
                  theme='legacy'
                    ref={gridRef}
                    rowGroupPanelShow="always"
                    rowData={rowData}
                    columnDefs={columnData}
                    animateRows
                    rowSelection="multiple"
                    defaultColDef={defaultColDef}
                  />
                </div>
              </div>
            </div>
          ) : (
            { showComponent } && <NoDataFoundComponent />
            //   No Data found component
          )}
        </div>
      </main>
    </>
  );
}

export default ISINSearchComponent;
